import { render, staticRenderFns } from "./files.vue?vue&type=template&id=c21ea688&scoped=true&"
import script from "./files.vue?vue&type=script&lang=js&"
export * from "./files.vue?vue&type=script&lang=js&"
import style0 from "./files.vue?vue&type=style&index=0&id=c21ea688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21ea688",
  null
  
)

export default component.exports